import React from 'react';

// Components
import Input from '../../Input';
import InputRow from '../../InputRow';
import StripeCardInput from '../../Stripe/CardInput';

interface Props {
  form: {
    nameOnCard: string;
    email: string;
    selectedTestLocation?: any;
    dateRange?: any;
  };
  onChange: (value: any, key: string) => void;
}

function PaymentMethodSection({ form, onChange }: Props) {
  const { nameOnCard } = form;

  return (
    <InputRow>
      <Input
        forId="Payment-Method"
        header="Payment Method"
        value={nameOnCard}
        onChange={e => onChange(e.target.value, 'nameOnCard')}
        placeholder="Name on Card"
        // errorMessage={this.getErrorMessage({ nameRequired })}
      />
      <StripeCardInput />
    </InputRow>
  );
}

export default PaymentMethodSection;
